// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BugFilledSvg from "@ant-design/icons-svg/es/asn/BugFilled";
import AntdIcon from '../components/AntdIcon';

var BugFilled = function BugFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BugFilledSvg
  }));
};

BugFilled.displayName = 'BugFilled';
export default React.forwardRef(BugFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/BugFilled.js
// module id = 683
// module chunks = 0